import API from '../../api/api'

export const GET_CHECKLISTS_HISTORY = 'GET_CHECKLISTS_HISTORY'
export const SET_CHECKLISTS_LOADING = 'SET_CHECKLISTS_LOADING'
export const SET_TEMPLATES = 'SET_TEMPLATES'
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE'
export const SET_CHECKLIST_TEMPLATE = 'SET_CHECKLIST_TEMPLATE'
export const SET_CHECKLIST = 'SET_CHECKLIST'
export const ADD_NEW_TEMPLATE = 'ADD_NEW_TEMPLATE'
export const REMOVE_TEMPLATE = 'REMOVE_TEMPLATE'
export const UPDATE_CHECKLIST = 'UPDATE_CHECKLIST'
export const REMOVE_CHECKLIST = 'REMOVE_CHECKLIST'
export const GET_CHECKLISTS_DASHBOARD_RESIDENTS = 'GET_CHECKLISTS_DASHBOARD_RESIDENTS'
export const TOGGLE_CHECKLISTS_HISTORY_HAS_UPDATED = 'TOGGLE_CHECKLISTS_HISTORY_HAS_UPDATED'
export const SET_CHECKLISTS_SETTINGS = 'SET_CHECKLISTS_SETTINGS'
export const GET_CUSTOM_CHECKLISTS = 'GET_CUSTOM_CHECKLISTS'
export const ADD_CUSTOM_TASK = 'ADD_CUSTOM_TASK'
export const UPDATE_CUSTOM_TASK = 'UPDATE_CUSTOM_TASK'
export const TOGGLE_REVISION_MODE = 'TOGGLE_REVISION_MODE'

export const initialState = {
  checklistsHistory: [],
  checklistsResidents: [],
  customChecklists: [],
  selectedChecklist: null,
  selectedChecklistTemplate: {
    data: null,
    mode: null,
  },
  allTemplates: null,
  loadedAllHistory: false,
  loadingHistory: false,
  revisionMode: false,
  checklistsHistoryHasUpdated: false,
  checklistsSettings: {
    active: [],
    notActive: [],
  },
}

const removeDuplic = (arr) => {
  const tempArr = []
  return arr
    .map((obj) => {
      if (!tempArr.includes(obj.id)) {
        tempArr.push(obj.id)
        return obj
      } else {
        return undefined
      }
    })
    .filter((x) => x)
}

const checklistsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHECKLISTS_HISTORY:
      if (action.page === 1) {
        return {
          ...state,
          checklistsHistory: removeDuplic(action.checklistsHistory),
          loadedAllHistory: action.loadedAllHistory,
        }
      } else {
        return {
          ...state,
          checklistsHistory: removeDuplic([
            ...state.checklistsHistory,
            ...action.checklistsHistory,
          ]),
          loadedAllHistory: action.loadedAllHistory,
        }
      }
    case UPDATE_CHECKLIST:
      const updatedData = state.checklistsHistory.map((checklist) =>
        checklist.id === action.updatedData.id ? action.updatedData : checklist,
      )
      return {
        ...state,
        checklistsHistory: updatedData,
        selectedChecklist: action.updatedData.type === 'task' ? null : action.updatedData,
        checklistsHistoryHasUpdated: true,
      }
    case REMOVE_CHECKLIST:
      return {
        ...state,
        checklistsHistory: state.checklistsHistory.filter(
          (checklist) => checklist.id !== action.removeId,
        ),
        selectedChecklist: null,
        checklistsHistoryHasUpdated: true,
      }
    case SET_TEMPLATES:
      return {
        ...state,
        allTemplates: action.allTemplates,
      }
    case UPDATE_TEMPLATE:
      const updated = state.allTemplates[action.updateData.tempCategory].map((temp) =>
        temp.id === action.updateData.data.id ? action.updateData.data : temp,
      )
      return {
        ...state,
        allTemplates: {
          ...state.allTemplates,
          [action.updateData.tempCategory]: updated,
        },
      }
    case REMOVE_TEMPLATE:
      const filteredData = state.allTemplates[action.removeData.tempCategory].filter(
        (temp) => temp.id !== action.removeData.id,
      )
      return {
        ...state,
        allTemplates: {
          ...state.allTemplates,
          [action.removeData.tempCategory]: filteredData,
        },
      }
    case SET_CHECKLIST_TEMPLATE:
      return {
        ...state,
        selectedChecklistTemplate: {
          data: action.data,
          mode: action.mode,
        },
      }
    case SET_CHECKLIST:
      return {
        ...state,
        selectedChecklist: action.data,
      }
    case ADD_NEW_TEMPLATE:
      const category = action.data.isTemplate ? 'templates' : 'custom'
      const allTemplates = state.allTemplates || { templates: [], custom: [] }

      return {
        ...state,
        allTemplates: {
          ...allTemplates,
          [category]: [...(allTemplates[category] || []), action.data],
        },
      }
    case SET_CHECKLISTS_LOADING:
      return {
        ...state,
        loadingHistory: action.loadingHistory,
      }
    case GET_CHECKLISTS_DASHBOARD_RESIDENTS:
      return {
        ...state,
        checklistsResidents: action.checklistsResidents,
      }
    case TOGGLE_CHECKLISTS_HISTORY_HAS_UPDATED:
      return {
        ...state,
        checklistsHistoryHasUpdated: action.hasUpdated,
      }
    case SET_CHECKLISTS_SETTINGS:
      return {
        ...state,
        checklistsSettings: action.data,
      }
    case GET_CUSTOM_CHECKLISTS: {
      return {
        ...state,
        customChecklists: action.data,
      }
    }
    case ADD_CUSTOM_TASK: {
      return {
        ...state,
        customChecklists: [...state.customChecklists, action.data],
      }
    }
    case UPDATE_CUSTOM_TASK: {
      const customChecklists = state.customChecklists.map((task) =>
        task.id === action.data.id ? { ...task, ...action.data } : task,
      )
      const active = state.checklistsSettings.active.map((task) => {
        if (task.id === action.data.id) {
          return { ...task, ...action.data }
        }
        return task
      })
      const notActive = state.checklistsSettings.notActive.map((task) => {
        if (task.id === action.data.id) {
          return { ...task, ...action.data }
        }
        return task
      })
      return {
        ...state,
        customChecklists,
        checklistsSettings: {
          ...state.checklistsSettings,
          active,
          notActive,
        },
      }
    }
    case TOGGLE_REVISION_MODE: {
      return {
        ...state,
        revisionMode: action.data,
      }
    }
    default:
      return state
  }
}

// Actions
export const getChecklistHistoryWithCount = (
  page = 1,
  buildingId = 0,
  query = '',
  pageSize = 50,
  type,
  statuses,
  dateRange,
  residentsType,
  sortBy,
) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    return API.getChecklistHistoryWithCount(
      start,
      pageSize,
      buildingId,
      query,
      type,
      statuses,
      dateRange,
      residentsType,
      sortBy,
    )
      .then((historyData) => {
        dispatch({
          type: GET_CHECKLISTS_HISTORY,
          checklistsHistory: historyData.checklists,
          page: 1,
          loadedAllHistory: historyData.checklists.length < pageSize,
        })
        dispatch(setLoading(false))
        return Promise.resolve(historyData)
      })
      .catch((err) => {
        dispatch(setLoading(false))
        throw new Error(err)
      })
  }
}

export const fetchChecklistDashboardResidents = ({
  buildingId,
  page = 1,
  limit = 50,
  status,
  search,
  moveInDate,
}) => {
  return (dispatch) => {
    const skip = (page - 1) * limit
    return API.getChecklistDashboardResidents(buildingId, {
      skip,
      limit,
      status,
      search,
      moveInDate,
    })
      .then((res) => {
        dispatch({
          type: GET_CHECKLISTS_DASHBOARD_RESIDENTS,
          checklistsResidents: res.data.clients,
        })
        dispatch(setLoading(false))
        return Promise.resolve(res.data.count)
      })
      .catch((err) => {
        dispatch(setLoading(false))
        return Promise.reject(err)
      })
  }
}

export const updateChecklist = (updatedData) => {
  return function (dispatch) {
    return API.updateChecklist(updatedData).then(({ data }) => {
      dispatch({
        type: UPDATE_CHECKLIST,
        updatedData: data,
      })
    })
  }
}

export const removeChecklist = (id) => {
  return function (dispatch) {
    return API.removeChecklist(id).then(() => {
      dispatch({
        type: REMOVE_CHECKLIST,
        removeId: id,
      })
    })
  }
}

export const createNewChecklistTemplate = (sendData) => {
  return function (dispatch) {
    return API.createNewChecklistTemplate(sendData)
      .then(({ data }) => {
        dispatch({
          type: ADD_NEW_TEMPLATE,
          data,
        })
        return data
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to create checklist'
        throw new Error(errorMessage)
      })
  }
}

export const getManageInspectionAllTemplates = (buildingId) => {
  return function (dispatch) {
    return API.getManageInspectionAllTemplates(buildingId).then((allTemplates) => {
      dispatch({
        type: SET_TEMPLATES,
        allTemplates,
      })
    })
  }
}

export const updateChecklistTemplate = ({ checklistId, sendData, tempCategory }) => {
  return function (dispatch) {
    return API.updateChecklistTemplate(checklistId, sendData)
      .then(({ data }) => {
        dispatch({
          type: UPDATE_TEMPLATE,
          updateData: { data, tempCategory },
        })
        return data
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to update checklist'
        throw new Error(errorMessage)
      })
  }
}

export const updateChecklistTemplateStatus = (checklistId, sendData, tempCategory) => {
  return function (dispatch) {
    return API.updateChecklistTemplateStatus(checklistId, sendData).then(({ data }) => {
      dispatch({
        type: UPDATE_TEMPLATE,
        updateData: { data, tempCategory },
      })
    })
  }
}

export const removeChecklistTemplate = (checklistId, isTemplate) => {
  const tempCategory = isTemplate ? 'templates' : 'custom'
  return function (dispatch) {
    return API.removeChecklistTemplate(checklistId).then(() => {
      dispatch({
        type: REMOVE_TEMPLATE,
        removeData: { id: checklistId, tempCategory },
      })
    })
  }
}

export const setSelectedChecklistTemplate = (checklistData) => {
  return function (dispatch) {
    dispatch({
      type: SET_CHECKLIST_TEMPLATE,
      data: checklistData.data,
      mode: checklistData.mode,
    })
  }
}

export const setSelectedChecklist = (checklistData) => {
  return function (dispatch) {
    dispatch({
      type: SET_CHECKLIST,
      data: checklistData,
    })
  }
}

export const setLoadingState = (loadingHistory) => {
  return function (dispatch) {
    dispatch(setLoading(loadingHistory))
  }
}

const setLoading = (loadingHistory) => {
  return {
    type: SET_CHECKLISTS_LOADING,
    loadingHistory,
  }
}

export const createCustomTask = (data) => (dispatch) => {
  return API.createCustomTask(data)
    .then((res) => {
      dispatch({
        type: ADD_CUSTOM_TASK,
        data: res.data,
      })
      return Promise.resolve(res.data)
    })
    .catch((err) => Promise.reject(err))
}

export const updateCustomTask = (checklistId, data) => () => {
  return API.updateCustomTask(checklistId, data)
    .then((res) => {
      return Promise.resolve(res.data)
    })
    .catch((err) => Promise.reject(err))
}

export const getResidentTasks = (residentId) => (dispatch) => {
  return API.getResidentTasksDetails(residentId)
    .then((res) => {
      dispatch({ type: TOGGLE_CHECKLISTS_HISTORY_HAS_UPDATED, hasUpdated: false })
      return Promise.resolve(res.data)
    })
    .catch((err) => Promise.reject(err))
}

export const sendChecklistReminder = (data) => () => {
  return API.sendChecklistReminder(data)
    .then(() => Promise.resolve())
    .catch((err) => Promise.reject(err))
}

export const updateCustomTaskStatus = (taskId, status) => () => {
  return API.updateCustomTaskStatus(taskId, status)
    .then(() => {
      return Promise.resolve()
    })
    .catch((err) => Promise.reject(err))
}

export const getChecklistsSettings = (buildingId) => (dispatch) => {
  return API.getChecklistsSettings(buildingId)
    .then((res) => {
      dispatch({ type: SET_CHECKLISTS_SETTINGS, data: res.data })
      return Promise.resolve(res.data)
    })
    .catch((err) => Promise.reject(err))
}

export const setChecklistsSettings = (data) => (dispatch) => {
  dispatch({ type: SET_CHECKLISTS_SETTINGS, data })
}

export const updateChecklistsSettings = (buildingId, data) => () =>
  API.updateChecklistsSettings(buildingId, data)
    .then(() => Promise.resolve())
    .catch((err) => Promise.reject(err))

export const fetchCustomTasks =
  ({ page = 1, buildingId = 0, search = '', type = 'all', limit = 50 }) =>
  (dispatch) => {
    const skip = (page - 1) * limit

    return API.getCustomTasks({ buildingId, search, skip, limit, type })
      .then((res) => {
        dispatch({
          type: GET_CUSTOM_CHECKLISTS,
          data: res.data.tasks,
        })
        return Promise.resolve(res.data.count)
      })
      .catch((err) => Promise.reject(err))
  }

export const duplicateCustomTask = (buildingId, checklistId) => (dispatch) => {
  return API.duplicateCustomTask({ buildingId, checklistId })
    .then((res) => {
      dispatch({
        type: ADD_CUSTOM_TASK,
        data: res.data,
      })
      return Promise.resolve()
    })
    .catch((err) => {
      throw new Error(err)
    })
}

export const removeCustomTask = (taskId) => () => {
  return API.removeChecklistTemplate(taskId)
    .then(() => Promise.resolve())
    .catch((err) => Promise.reject(err))
}

export const updateTaskAssignDays = (taskId, days) => (dispatch) => {
  dispatch({ type: UPDATE_CUSTOM_TASK, data: { id: taskId, assignTaskDays: days } })
  return API.updateTaskAssignDays(taskId, days)
    .then(() => Promise.resolve())
    .catch((err) => Promise.reject(err))
}

export const updateTaskDueDateDays = (taskId, days) => (dispatch) => {
  dispatch({ type: UPDATE_CUSTOM_TASK, data: { id: taskId, dueDateDays: days } })
  return API.updateTaskDueDateDays(taskId, days)
    .then(() => Promise.resolve())
    .catch((err) => Promise.reject(err))
}

export const toggleRevisionMode = (data) => (dispatch) =>
  dispatch({ type: TOGGLE_REVISION_MODE, data })

// Selectors
export const selectChecklistsHistory = (state) => state.checklistsHistory.checklistsHistory

export const selectChecklistsDefaultTemplates = (state) => state.checklistsHistory.allTemplates

export const getSelectedChecklistTemplate = (state) =>
  state.checklistsHistory.selectedChecklistTemplate

export const getSelectedChecklist = (state) => state.checklistsHistory.selectedChecklist

export const selectStatusOfLoading = (state) => state.checklistsHistory.loadingHistory

export const selectStatusIsLoadedAll = (state) => state.checklistsHistory.loadedAllHistory

export const selectChecklistDashboardResidents = (state) =>
  state.checklistsHistory.checklistsResidents

export const selectChecklistsHistoryHasUpdated = (state) =>
  state.checklistsHistory.checklistsHistoryHasUpdated

export const selectChecklistsSettings = (state) => state.checklistsHistory.checklistsSettings

export const selectCustomTasks = (state) => state.checklistsHistory.customChecklists

export const selectRevisionMode = (state) => state.checklistsHistory.revisionMode

export default checklistsReducer
